var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowTop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 26,
  fill: "none",
  viewBox: "0 0 19 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.259 9.914a4 4 0 0 1 0 6.172L6.545 24.922C3.936 27.074 0 25.218 0 21.836V4.164C0 .782 3.936-1.074 6.545 1.078z"
})));
export { SvgArrowTop as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAxOSAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjI1ODYgOS45MTQxOEMxOS4xOTg1IDExLjUxNDEgMTkuMTk4NSAxNC40ODU5IDE3LjI1ODYgMTYuMDg1OEw2LjU0NTE0IDI0LjkyMjJDMy45MzYxOCAyNy4wNzQgNC45OTA0NWUtMDcgMjUuMjE4MiA2LjQ2ODcyZS0wNyAyMS44MzY0TDEuNDE5MzdlLTA2IDQuMTYzNjVDMS41NjcyZS0wNiAwLjc4MTc4IDMuOTM2MTggLTEuMDc0IDYuNTQ1MTQgMS4wNzc4M0wxNy4yNTg2IDkuOTE0MThaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";